import { RouteConfig } from 'vue-router'

const Create = () => import('../views/autumn-2022/Create.vue')
const List = () => import('../views/autumn-2022/List.vue')
const Preview = () => import('../views/autumn-2022/Preview.vue')
const PreHeat = () => import('../views/NewTremPreHeat.vue')
const PreHeatRules = () => import('../views/NewTremPreHeatRules.vue')
const NewTermNotify = () => import('../views/NewTermHomeworkNotify.vue')
const Detail = () => import('../views/autumn-2022/Detail.vue')
export const preHeatRulesRoute: RouteConfig = {
  path: '/2022-autumn/rules',
  name: '2022_autumn_rules',
  component: PreHeatRules,
  meta: {
    title: '规则详情',
  },
}

export const preHeatRoute: RouteConfig = {
  path: '/2022-autumn',
  name: '2022_autumn',
  component: PreHeat,
  props: (route) => ({ qd: route.query.qd }),
  meta: {
    title: '2022开学季',
  },
}

export const createRoute: RouteConfig = {
  path: '/autumn2022-homework/create',
  name: 'autumn2022_homework_create',
  component: Create,
  props: (route) => {
    return { ...route.query }
  },
  meta: {
    title: '布置新学期作业',
  },
}

export const previewRoute: RouteConfig = {
  path: '/autumn2022-homework/preview',
  name: 'autumn2022_homework_preview',
  component: Preview,
  props: (route) => {
    return { ...route.query }
  },
}

export const listRoute: RouteConfig = {
  path: '/autumn2022-homework/list',
  name: 'autumn2022_homework_list',
  component: List,
  props: (route) => {
    return { ...route.query }
  },
  meta: {
    title: '新学期作业计划',
  },
}
export const notifyRoute: RouteConfig = {
  path: '/autumn2022-homework/notify',
  name: 'autumn2022_homework_notify',
  component: NewTermNotify,
  props: (route) => {
    return { ...route.query }
  },
}

export const detailRoute: RouteConfig = {
  path: '/autumn2022-homework/detail',
  name: 'autumn2022_homework_detail',
  component: Detail,
  props: (route) => {
    return { ...route.query }
  },
  meta: {
    title: '作业计划详情',
  },
}

export default [preHeatRoute, preHeatRulesRoute, createRoute, listRoute, previewRoute, notifyRoute, detailRoute]
